__webpack_require__.p = "/snap-simple-keyring/latest/";